define('plugin/deposit-paid-events/view/DepositPaidEventsPayDepositAmountView',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Deposit paid events pay deposit amount view
     *
     * @class DepositPaidEventsPayDepositAmountView
     */
    return Marionette.ItemView.extend({

        template: '#deposit_paid_events_pay_deposit_amount_view',

        ui: {
            btn: '#sb_deposit_paid_events_pay_deposit_amount_btn',
        },

        events: {
            'click @ui.btn': 'payDepositAmount'
        },

        payDepositAmount: function () {
            this.triggerMethod('pay:deposit:amount', this.model);
        },

        serializeData: function () {
            return _.extend(Marionette.ItemView.prototype.serializeData.apply(this), {
                'isDisabledBtn': this.model.get('package_instances').length || this.model.get('promotion_instances').length
            });
        }
    });

});
